// @ts-check
import React, { Component } from 'react';
import { makeObservable, observable, action } from 'mobx';
import 'Styles/commonComponents.scss';
import IconsContainer from 'Utils/IconsContainer';
import { observer } from 'mobx-react';

/**
 * @typedef {object} props
 * @property {number | null | undefined} minValue
 * @property {number | null | undefined} maxValue
 * @property {() => number} getValue
 * @property {(val: number) => void} setValue
 * @extends {Component<props>}
 */
class NumericInput extends Component {
    /**
     * @param {React.KeyboardEvent<HTMLInputElement>} e
     */
    OnChange(e) {
        let val = Number(e.target.value);
        if (Number.isNaN(val)) {
            e.preventDefault();
            return;
        }
        this.OnChangeValueImpl(val);
    }

    UpValue() {
        this.OnChangeValueImpl(this.props.getValue() + 1);
    }

    DownValue() {
        this.OnChangeValueImpl(this.props.getValue() - 1);
    }

    OnChangeValueImpl(val) {
        if (val == null || Number.isNaN(val)) {
            val = this.props.minValue ?? 0;
        }
        if (this.props.maxValue != null && val > this.props.maxValue) {
            val = this.props.maxValue;
            if (this.props.onResetToDefaultMax)
                this.props.onResetToDefaultMax();
        }
        else if (this.props.minValue != null && val < this.props.minValue) {
            val = this.props.minValue;
            if (this.props.onResetToDefaultMin)
                this.props.onResetToDefaultMin();
        }

        if (this.props.setValue)
            this.props.setValue(val);
    }

    render() {
        return (
            <div className='numeric-input'>
                <input
                    value={this.props.getValue()}
                    onChange={action(e => this.OnChange(e))}
                />
                <div className='numeric-input-buttons-container'>
                    <button className='numeric-up-button numeric-button' onClick={action(_ => this.UpValue())}>
                        {IconsContainer.Get('ci-arrow-up')}
                    </button>
                    <button className='numeric-down-button numeric-button' onClick={action(_ => this.DownValue())}>
                        {IconsContainer.Get('ci-arrow-down')}
                    </button>
                </div>
            </div>
        );
    }
}

export default observer(NumericInput);